
	{
	  "apiUrl": "../_api/rest",
	  "title": "Cohelion | Cohelion Demo Aviation",
	  "supportEmail": "support@cohelion.com",
	  "customerName": "Cohelion Demo Aviation",
	  "dsnSentry": "https://970e1dc9bc08466d93aaf9ccf64db290@errors.cohelion.com/34",
	  "translationLocation": "/client/assets/i18n",
	  "googleMapsApiKey": "AIzaSyBA2TUkcIjk8ZAXembREE9OFZRPZHFdbnE",
	  "environment": "Preview",
	  "useMockData": false
	}